import React, { useEffect, useState } from "react";
import { ColorPicker } from "primereact/colorpicker";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCroppedImage,
  fetchHomeJsonList,
  saveThemeJsonData,
} from "../../../redux/Actions";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import ImageCropper from "../../imageCropper/imageCropper";

const SectionOneThemeTwoEdit = () => {
  const dispatch = useDispatch<any>();
  const [editData, setEditData] = useState<any>();
  const jsonData: any = useSelector<any>((state) => state.homeJsonList);
  const [activeTab, setActiveTab] = useState(0);
  const [cropImageHeight, setCropImageHeight] = useState("");
  const [cropImageWidth, setCropImageWidth] = useState("");
  const [selectedCropImage, setSelectedCropImage] = useState("");
  const [showCropModal, setShowCropModal] = useState<boolean>(false);
  const images = [
    "assets/img/theme_2/banner-slider-01.jpg",
    "assets/img/theme_2/banner-slider-02.jpg",
    "assets/img/theme_2/banner-slider-03.jpg",
    "assets/img/theme_2/banner-slider-04.jpg",
    "assets/img/theme_2/banner-slider-05.jpg",
    "assets/img/theme_2/banner-slider-01.jpg",
    "assets/img/theme_2/banner-slider-02.jpg",
    "assets/img/theme_2/banner-slider-03.jpg",
    "assets/img/theme_2/banner-slider-04.jpg",
    "assets/img/theme_2/banner-slider-05.jpg",
  ];
  const handleHeaderChange = (e: any) => {
    const { value, name, type, checked } = e.target;
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_2: {
        home: {
          ...prevJsonData.theme_2.home,
          section_1: {
            ...prevJsonData.theme_2.home.section_1,
            [name]: value,
          },
        },
      },
    }));
  };

  const saveJsonData = () => {
    dispatch(fetchHomeJsonList(editData));
    dispatch(saveThemeJsonData(editData));
  };

  const updateImageSectionOne = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150");
    // setCropImageWidth("300");
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result);
      };
    }
  };

  const handleCroppedImage = async (image: any) => {
    setShowCropModal(false);
    const imageLink = await dispatch(fetchCroppedImage(image));
    if (imageLink != false) {
      handleImageChange(imageLink);
    }
  };
  const handleImageChange = (image: string) => {
    let updated_card_section = [
      ...editData.theme_2.home.section_1.card_section,
    ];
    updated_card_section[activeTab] = image;
    //Update the banner value in the JSON data
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_2: {
        ...prevJsonData.theme_2,
        home: {
          ...prevJsonData.theme_2.home,
          section_1: {
            ...prevJsonData.theme_2.home.section_1,
            card_section: updated_card_section,
          },
        },
      },
    }));
  };
  useEffect(() => {
    setEditData(jsonData);
  }, [jsonData]);

  useEffect(() => {
    if (editData != undefined) {
      setEditData(editData);
    }
  }, [editData]);

  // HTML
  return (
    <>
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Section One Theme Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="edit-section">
              <h4 className="edit-section-hdr">Tittle Section </h4>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Tittle One</label>
                    <input
                      type="text"
                      className="form-control"
                      name="title_1"
                      value={editData?.theme_2?.home?.section_1?.title_1}
                      onChange={handleHeaderChange}
                      maxLength={250}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Tittle Two</label>
                    <input
                      type="text"
                      className="form-control"
                      name="title_2"
                      value={editData?.theme_2?.home?.section_1?.title_2}
                      onChange={handleHeaderChange}
                      maxLength={250}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Tittle Three</label>
                    <input
                      type="text"
                      className="form-control"
                      name="title_3"
                      value={editData?.theme_2?.home?.section_1?.title_3}
                      onChange={handleHeaderChange}
                      maxLength={250}
                    />
                  </div>
                </div>
              </div>
              <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className=" mb-3">
                    <label className="form-label">Button Text</label>
                    <input
                      type="text"
                      className="form-control"
                      name="btntext"
                      value={
                        editData?.theme_2?.home?.section_1?.btntext
                      }
                      onChange={handleHeaderChange}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className=" mb-3">
                    <label className="form-label">Background</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="btnbg_color"
                        value={
                          editData?.theme_2?.home?.section_1?.btnbg_color
                        }
                        onChange={handleHeaderChange}
                      />
                      <ColorPicker
                        name="btnbg_color"
                        format="hex"
                        onChange={handleHeaderChange}
                        value={
                          editData?.theme_2?.home?.section_1?.btnbg_color
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className=" mb-3">
                    <label className="form-label">Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="btncolor"
                        value={
                          editData?.theme_2?.home?.section_1?.btncolor
                        }
                        onChange={handleHeaderChange}
                      />
                      <ColorPicker
                        name="btncolor"
                        format="hex"
                        onChange={handleHeaderChange}
                        value={
                          editData?.theme_2?.home?.section_1?.btncolor
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Placeholder</label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        name="btnplaceholder"
                        value={
                          editData?.theme_2?.home?.section_1?.btnplaceholder
                        }
                        maxLength={250}
                        onChange={handleHeaderChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
              <ul className="nav nav-tabs">
                <Swiper
                  spaceBetween={15}
                  navigation={true}
                  modules={[Navigation]}
                  breakpoints={{
                    640: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 3,
                    },
                  }}
                  className="homejson-slider"
                >
                  {editData?.theme_2?.home?.section_1?.card_section.map(
                    (card: any, index: any) => (
                      <SwiperSlide key={index}>
                        <li key={index} className="nav-item nav-option">
                          <a
                            className={`nav-link ${
                              activeTab === index ? "active" : ""
                            }`}
                            onClick={() => setActiveTab(index)}
                          >
                            Image {index + 1}
                          </a>
                        </li>
                      </SwiperSlide>
                    )
                  )}
                </Swiper>
              </ul>
              <div className="tab-content">
                {editData?.theme_2?.home?.section_1?.card_section.map(
                  (card: any, index: any) => (
                    <div
                      key={index}
                      className={`tab-pane fade ${
                        activeTab === index ? "show active" : ""
                      }`}
                    >
                      <div className="row">
                        <div className="col-md-12">
                          <div className="img-bg active">
                            <img src={card} alt={`Card Icon ${index + 1}`} />
                          </div>
                          <div className="img-options w-100">
                            <Swiper
                              spaceBetween={15}
                              navigation={true}
                              modules={[Navigation]}
                              breakpoints={{
                                640: {
                                  slidesPerView: 1,
                                },
                                768: {
                                  slidesPerView: 4,
                                },
                                1024: {
                                  slidesPerView: 6,
                                },
                              }}
                              className="homejson-slider"
                            >
                              {images.map((icons, iconIndex) => (
                                <SwiperSlide key={iconIndex}>
                                  <div
                                    className="img-option"
                                    onClick={() => {
                                      handleImageChange(icons);
                                    }}
                                  >
                                    <img
                                      src={icons}
                                      alt="Hero Image"
                                      className="img-fluid"
                                    />
                                  </div>
                                </SwiperSlide>
                              ))}
                            </Swiper>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>
              <div className="mb-3">
                <label className="form-label">Upload Image</label>
                <input
                  type="file"
                  accept="image/png, image/jpeg"
                  className="form-control"
                  name="image"
                  onChange={updateImageSectionOne}
                />
              </div>
            </div>
            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={saveJsonData}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      {showCropModal ? (
        <>
          <div
            className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
            id="crop-modal"
            tabIndex={-1}
            aria-labelledby="crop-modal"
            aria-hidden="true"
            style={{ display: "block" }}
          >
            <ImageCropper
              src={selectedCropImage}
              height={cropImageHeight}
              width={cropImageWidth}
              handleCrop={handleCroppedImage}
              close={() => {
                setShowCropModal(false);
              }}
            />
          </div>
        </>
      ) : null}
    </>
  );
};

export default SectionOneThemeTwoEdit;
